import {
  CircularProgress,
} from '@material-ui/core/';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import {
  observer,
} from 'mobx-react';
import React from 'react';

interface IProps {
  open: boolean;
  loading?: boolean;
  handleClose(): void;
  handleUpdate(): Promise<void>;
}
interface IState {
}

@observer
class UpdateMembershipIdModal extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
  }

  handleMemberShipStateChange = (event: any) => {
    this.setState({
      newMembershipId: event.target.value,
    });
  };



  handleSubmit = async () => {

    try {
      await this.props.handleUpdate();
    } catch (error) {
      console.log(error);
    }
  };

  handleCancel = () => {
    this.props.handleClose();
  };

  render() {
    return (
      <div >
        <Dialog
          open={this.props.open}
          onClose={this.props.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Sperate</DialogTitle>
          <DialogContent >
            <DialogContentText>
              Please ask the member to register with the new membership in our mobile.
            </DialogContentText>

          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.handleCancel()} color="primary">
                    Cancel
            </Button>
            <Button
              onClick={() => this.handleSubmit()}
              color="primary"
            >
              { this.props.loading ? <CircularProgress /> : 'Update'}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default UpdateMembershipIdModal;
